import React from 'react';
import { pure, compose, withHandlers } from 'react-recompose';
// components
import { ActionsElement } from '../../actions-element';
// features
import PC from '../../../features/permission/role-permission';
// helpers/constants
import * as G from '../../../helpers';
// icons
import * as I from '../../../svgs';
//////////////////////////////////////////////////

const iconColor = G.getTheme('colors.dark.blue');

const enhance = compose(
  withHandlers({
    handleEditOrder: (props) => () => {
      const {
        closeFixedPopup,
        handleClickEditOrder,
      } = props;

      handleClickEditOrder();

      closeFixedPopup();
    },
    handleResetByReportGuid: (props) => () => {
      const {
        closeFixedPopup,
        handleClickResetByGuid,
      } = props;

      handleClickResetByGuid();

      closeFixedPopup();
    },
    handleResetByReportType: (props) => () => {
      const {
        closeFixedPopup,
        handleClickResetByType,
      } = props;

      handleClickResetByType();

      closeFixedPopup();
    },
  }),
  pure,
);

const getOptions = ({
  reportType,
  showEditView,
  handleEditOrder,
  handleResetByReportGuid,
  handleResetByReportType,
}) => ([
  ...showEditView ? [{
    permissions: [PC.ANY],
    action: handleEditOrder,
    frontIcon: I.gear(iconColor, 15, 15),
    text: G.getWindowLocale(
      'titles:edit-view',
      'Edit View',
    ),
  }] : [],
  {
    permissions: [PC.ANY],
    action: handleResetByReportGuid,
    frontIcon: I.refresh(iconColor, 15, 15),
    text: G.getWindowLocale(
      'actions:reset-current-columns-width',
      'Reset current report columns width',
    ),
  },
  {
    permissions: [PC.ANY],
    action: handleResetByReportType,
    frontIcon: I.refresh(iconColor, 15, 15),
    // eslint-disable-next-line max-len
    text: `${G.getWindowLocale('actions:reset-all', 'Reset all')} ${G.getEnumLocale(reportType)} ${G.getWindowLocale('titles:report-column-width', 'reports columns width')}`.trim(),
  },
]);

export const ResizeActions = (props) => <ActionsElement options={getOptions(props)} />;

export default enhance(ResizeActions);
